import { FormItem, NumberInput } from '@framework/form';
import { RowElement } from '@framework/ui';
import React from 'react';
import { $SpaceCompact } from '../../../../ui/form/SpaceCompact';
import { RuleType } from '../../IRule';
import { CustomValidationRuleMessage } from '../custom/CustomValidationRuleMessage';

const fieldName = `rules.${RuleType.ItemRange}`;

export interface IItemRangeRuleComponentProps {}

export function ItemRangeRuleComponent(props: IItemRangeRuleComponentProps) {
  return (
    <RowElement>
      <FormItem
        name={`${fieldName}.min`}
        label="Minimo spunte"
        help="Numero minimo di voci spuntate."
      >
        <$SpaceCompact block size="large">
          <NumberInput name={`${fieldName}.min`} />
          <CustomValidationRuleMessage name={`${fieldName}.minCustomMessage`} />
        </$SpaceCompact>
      </FormItem>

      <FormItem
        name={`${fieldName}.max`}
        label="Massimo spunte"
        help="Numero massimo di voci spuntate."
      >
        <$SpaceCompact block size="large">
          <NumberInput name={`${fieldName}.max`} />
          <CustomValidationRuleMessage name={`${fieldName}.maxCustomMessage`} />
        </$SpaceCompact>
      </FormItem>
    </RowElement>
  );
}
